export default __webpack_public_path__ + "static/media/shoes5.b4152efc.jpeg";